import { createEngineResult } from "@energyos/shared-types";
import { packModules } from "./raster.js";
import { kwpFromCount, packingDensity } from "./kwp.js";
import { detectMissingInputs } from "./missing.js";
/** Berechnet die deterministische Modulbelegung einer Dachfläche. */
export function computeModuleLayout(plane, obstacles, exclusions, opts) {
    if (plane.vertices.length < 3) {
        return createEngineResult("failed", null, {
            errors: [{ code: "validation_error", message: "Dachpolygon braucht ≥ 3 Punkte." }],
        });
    }
    if (!(opts.moduleSpec.widthM > 0 && opts.moduleSpec.heightM > 0 && opts.moduleSpec.wp > 0)) {
        return createEngineResult("failed", null, {
            errors: [{ code: "validation_error", message: "Modul-Spec (Breite/Höhe/Wp) muss > 0 sein." }],
        });
    }
    const { modules, roofAreaM2 } = packModules(plane, obstacles, exclusions, opts);
    const count = modules.length;
    const kwp = kwpFromCount(count, opts.moduleSpec.wp);
    const moduleFootprintM2 = opts.moduleSpec.widthM * opts.moduleSpec.heightM;
    const density = packingDensity(count * moduleFootprintM2, roofAreaM2);
    const layout = {
        moduleSpec: opts.moduleSpec,
        orientation: opts.orientation,
        setbacks: opts.setbacks,
        modules: modules.map((m) => ({ corners: m.corners, orientation: m.orientation, row: m.row, col: m.col })),
        count,
        kwp,
        packingDensity: Math.round(density * 1000) / 1000,
    };
    const assumptions = [];
    if (!plane.tiltConfirmed) {
        assumptions.push({
            field: "tiltDeg",
            assumed: plane.tiltDeg,
            reason: "Dachneigung nicht bestätigt — als Annahme geführt.",
            impactOnResult: "medium",
        });
    }
    if (!plane.scaleConfirmed) {
        assumptions.push({
            field: "scale",
            assumed: "unbestätigt",
            reason: "Maßstab nicht bestätigt — Fläche/Modulanzahl unsicher.",
            impactOnResult: "high",
        });
    }
    const warnings = [];
    if (count === 0) {
        warnings.push({
            code: "no_modules_placed",
            message: "Keine Module platzierbar — Fläche, Hindernisse oder Randabstände prüfen.",
            severity: "warning",
        });
    }
    const missingData = detectMissingInputs(plane);
    const status = count === 0
        ? "needs_user_review"
        : warnings.length > 0 || missingData.length > 0
            ? "success_with_warnings"
            : "success";
    const confidenceScore = plane.scaleConfirmed && plane.tiltConfirmed ? 0.9 : 0.6;
    // createEngineResult setzt missingData NICHT (vgl. reasoning-core/result.ts) — nachziehen.
    const result = createEngineResult(status, layout, {
        warnings,
        assumptions,
        confidenceScore,
    });
    result.missingData = missingData;
    return result;
}
//# sourceMappingURL=layout.js.map